import React, { FC } from 'react'
import format from 'date-fns/format'
import ja from 'date-fns/locale/ja'
import { CardInner, SettingsWarningCard, StoreDeliveryFeePackageSize } from 'components/Card'
import { SettingsAccordion, SettingsAccordionItem } from 'components/Accordion'
import { StockType } from 'types/stock'
import { Spacer } from 'components/Utility'
import { parseToDate } from 'lib/helper'
import { PackageSize } from 'types/storeDeliveryFee'

type Props = {
  breadName: string
  expandStatus: string
  imageUrl: string
  packageSize: PackageSize
  resetExpandedStatus: () => void
  stocks: StockType[]
}

const StoreDeliveryFeeConfirmCard: FC<Props> = (props) => {
  const { breadName, expandStatus, imageUrl, packageSize, resetExpandedStatus, stocks } = props

  return (
    <SettingsAccordion
      breadName={breadName}
      expandStatus={expandStatus}
      imageUrl={imageUrl}
      resetExpandedStatus={resetExpandedStatus}
    >
      <SettingsAccordionItem>
        <StoreDeliveryFeePackageSize
          headline={'配送料金が未設定の配送サイズ'}
          packageSize={packageSize}
          title={'取り寄せの設定'}
        />
        <CardInner>
          <SettingsWarningCard
            description={'以下のお届け可能日は削除され、お客さまが購入できなくなります。'}
            content={stocks.map((stock) => format(parseToDate(stock.date), 'M月d日（E）', { locale: ja })).join(', ')}
            title={'削除されるお届け可能日'}
          />
          <Spacer size={4} />
          <Spacer size={8} />
        </CardInner>
      </SettingsAccordionItem>
    </SettingsAccordion>
  )
}

export default StoreDeliveryFeeConfirmCard
